(() => {
  if (customElements.get('snd-banner-categories')) return;

  class SndBannerCategories extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.track = this.querySelector('[data-promo-track]');
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.track) return;

      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onMouseEnter = () => this.pause();
      this.onMouseLeave = () => this.start();
      this.onFocusIn = () => this.pause();
      this.onFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      };
      this.onPointerDown = () => this.pause();
      this.onPointerUp = () => this.start();
      this.onVisibilityChange = () => (document.hidden ? this.pause() : this.start());
      this.onResize = () => this.updateOverflow();

      this.previousButton?.addEventListener('click', this.onPrevious);
      this.nextButton?.addEventListener('click', this.onNext);
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      this.track.addEventListener('pointerdown', this.onPointerDown, { passive: true });
      this.track.addEventListener('pointerup', this.onPointerUp, { passive: true });
      this.track.addEventListener('pointercancel', this.onPointerUp, { passive: true });
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.track);
      this.updateOverflow();
      this.start();
    }

    disconnectedCallback() {
      this.pause();
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      this.track?.removeEventListener('pointerdown', this.onPointerDown);
      this.track?.removeEventListener('pointerup', this.onPointerUp);
      this.track?.removeEventListener('pointercancel', this.onPointerUp);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.resizeObserver?.disconnect();
      this.initialized = false;
    }

    updateOverflow() {
      if (!this.track) return;
      const hasOverflow = this.track.scrollWidth - this.track.clientWidth > 2;
      this.toggleAttribute('data-has-overflow', hasOverflow);
      if (!hasOverflow) this.pause();
      if (hasOverflow && !this.timer) this.start();
    }

    move(direction) {
      if (!this.track) return;
      const card = this.track.querySelector('[data-promo-card]');
      if (!card) return;

      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const current = this.track.scrollLeft;
      let target = current + direction * step;

      if (direction > 0 && current >= maximum - 3) target = 0;
      if (direction < 0 && current <= 3) target = maximum;

      this.track.scrollTo({
        left: Math.max(0, Math.min(target, maximum)),
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
      });
    }

    start() {
      this.pause();
      if (this.dataset.autoplay !== 'true') return;
      if (this.reducedMotion.matches || document.hidden) return;
      if (!this.hasAttribute('data-has-overflow')) return;

      const seconds = Math.max(1, Number(this.dataset.autoplaySeconds) || 5);
      this.timer = window.setInterval(() => this.move(1), seconds * 1000);
    }

    pause() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = undefined;
    }
  }

  customElements.define('snd-banner-categories', SndBannerCategories);

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('snd-banner-categories');
    if (!section) return;
    section.pause();
    event.target.closest('[data-promo-card]')?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  });
})();
